export const customizeDomain = (customDomain) => {
    if (customDomain) {
        const faviconUrl = customDomain.faviconUrl;
        const link = document.createElement('link');
        link.rel = 'icon';
        link.type = 'image/x-icon';
        link.href = faviconUrl;

        // Remove any existing favicon links
        const existingIcons = document.querySelectorAll("link[rel*='icon']");
        existingIcons.forEach((el) => el.parentNode?.removeChild(el));
        document.head.appendChild(link);
        document.title = customDomain.title;
    }
};
